// extracted by mini-css-extract-plugin
export default {"container":"container-mf2LWneM","header":"header-AINLozy3","title":"title-lCcXa3Bi","wasDiceUnfair":"wasDiceUnfair-XqMkGnf3","grayBar":"grayBar-V4jj25ai"};